<template>
  <div class="tw-flex tw-flex-col tw-gap-8 tw-p-8 tw-w-full tw-rounded-xl tw-bg-white tw-relative">
    <slot />
  </div>
</template>
